var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"nou-toast-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"nou-toast",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }